/**
 * 营运中心 / 货物跟踪
 */

export default {
  // 回显跟踪记录中 到达日期 字段
  track_waybill_backfill_arrival_date: ['90030','73730'], // 202510231712343534506
  // 关联车辆
  track_waybill_backfill_vehicle_no: ['60266','82635','90100'], // 202512271721042834491
}
